import PermissionsChecklist, {
  toTrytonDate,
} from "../StaffShiftSchedule/PermissionsChecklist";

function ModalEvents(props) {
  const { record } = props;
  return (
    <PermissionsChecklist
      readOnly
      label="staff.access.permissions"
      record={{
        ...record,
        shift_date: toTrytonDate(record?.enter_timestamp),
      }}
    />
  );
}

export default ModalEvents;